var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edicion_block"},[_c('h4',{staticClass:"mb10",staticStyle:{"font-size":"22px"}},[_vm._v(_vm._s(_vm.$t('sobre.presiona')))]),_vm._v(" "),_c('img',{staticStyle:{"display":"table","margin":"40px auto","max-height":"200px"},attrs:{"src":require("@/assets/images/editar_bg.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }